import { updateField } from 'vuex-map-fields';

export default {
  START_LOADING_TEAMS(state) {
    state.teamsLoaded = false;
  },
  SET_TEAMS_LIST(state, payload) {
    state.teamList = payload;
    state.teamsLoaded = true;
  },
  TEAM_SAVED(state, payload) {
    state.teamSaved = payload;
  },
  TEAM_DELETED(state, payload) {
    state.teamDeleted = payload;
  },
  API_ERROR(state, payload) {
    if (payload) {
      state.apiError = payload;
    }
  },
  updateField,
};
